import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface OutcomeChange {
  clientId: number;
  guid: string;
  origin: object;
}

/** Refresh mounted case/client views after a write without sharing their state. */
@Injectable({ providedIn: 'root' })
export class OutcomeChangesService {
  private readonly changes = new Subject<OutcomeChange>();
  readonly changed = this.changes.asObservable();

  notify(change: OutcomeChange): void {
    this.changes.next(change);
  }
}
